import { defineComponent as _defineComponent } from 'vue';
import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, unref as _unref, createVNode as _createVNode, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = (n) => (_pushScopeId("data-v-30b36515"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "fase-wrapper" };
const _hoisted_2 = { class: "phase-header" };
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "phase-header-left" }, [
    /*#__PURE__*/ _createElementVNode("div", { class: "phase-badge" }, "Fase 3"),
    /*#__PURE__*/ _createElementVNode("div", null, [
        /*#__PURE__*/ _createElementVNode("h2", { class: "phase-title" }, "Auditoría Administrativa y Cuadre de Costos"),
        /*#__PURE__*/ _createElementVNode("p", { class: "phase-desc" }, "Revisión de montos contra lo recibido, aplicación de descuentos y cuadre fiscal.")
    ])
], -1 /* HOISTED */));
const _hoisted_4 = {
    key: 0,
    class: "phase-actions"
};
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "lni lni-save" }, null, -1 /* HOISTED */));
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "lni lni-checkmark-circle" }, null, -1 /* HOISTED */));
const _hoisted_7 = { key: 0 };
const _hoisted_8 = { class: "panel-section" };
const _hoisted_9 = { class: "section-icon-title" };
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "section-icon purple" }, [
    /*#__PURE__*/ _createElementVNode("i", { class: "lni lni-calculator" })
], -1 /* HOISTED */));
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h3", { class: "section-title" }, "Ingresos Pendientes de Verificación", -1 /* HOISTED */));
const _hoisted_12 = {
    key: 0,
    class: "count-badge"
};
const _hoisted_13 = {
    key: 0,
    class: "empty-state-sm"
};
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "lni lni-checkmark-circle text-success" }, null, -1 /* HOISTED */));
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "No hay ingresos pendientes de verificación. Todo está cuadrado.", -1 /* HOISTED */));
const _hoisted_16 = [
    _hoisted_14,
    _hoisted_15
];
const _hoisted_17 = {
    key: 1,
    class: "table-scroll"
};
const _hoisted_18 = { class: "data-table" };
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("thead", null, [
    /*#__PURE__*/ _createElementVNode("tr", null, [
        /*#__PURE__*/ _createElementVNode("th", null, "Nro. Factura"),
        /*#__PURE__*/ _createElementVNode("th", null, "Proveedor"),
        /*#__PURE__*/ _createElementVNode("th", null, "Moneda"),
        /*#__PURE__*/ _createElementVNode("th", { class: "text-end" }, "Total Facturado"),
        /*#__PURE__*/ _createElementVNode("th", { class: "text-center" }, "Estado"),
        /*#__PURE__*/ _createElementVNode("th", { class: "text-end" }, "Acción")
    ])
], -1 /* HOISTED */));
const _hoisted_20 = { class: "code-badge primary" };
const _hoisted_21 = { class: "text-muted d-block mt-1" };
const _hoisted_22 = { class: "font-medium" };
const _hoisted_23 = { class: "ref-badge" };
const _hoisted_24 = { class: "text-end font-bold text-success" };
const _hoisted_25 = { class: "text-center" };
const _hoisted_26 = { class: "status-badge warning" };
const _hoisted_27 = { class: "text-end" };
const _hoisted_28 = ["onClick"];
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "lni lni-revenue" }, null, -1 /* HOISTED */));
const _hoisted_30 = {
    key: 1,
    class: "audit-grid"
};
const _hoisted_31 = { class: "audit-main-col" };
const _hoisted_32 = { class: "panel-section" };
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "section-icon-title mb-3" }, [
    /*#__PURE__*/ _createElementVNode("div", { class: "section-icon purple" }, [
        /*#__PURE__*/ _createElementVNode("i", { class: "lni lni-calculator" })
    ]),
    /*#__PURE__*/ _createElementVNode("h3", { class: "section-title" }, "Ajuste de Costos y Descuentos")
], -1 /* HOISTED */));
const _hoisted_34 = {
    class: "table-scroll",
    style: { "max-height": "480px" }
};
const _hoisted_35 = { class: "data-table" };
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("thead", null, [
    /*#__PURE__*/ _createElementVNode("tr", null, [
        /*#__PURE__*/ _createElementVNode("th", null, "Img"),
        /*#__PURE__*/ _createElementVNode("th", null, "Facturación Física (Digitada)"),
        /*#__PURE__*/ _createElementVNode("th", null, "Producto Vinculado"),
        /*#__PURE__*/ _createElementVNode("th", { class: "text-center" }, "C. Pedida"),
        /*#__PURE__*/ _createElementVNode("th", { class: "text-center" }, "C. Llegó"),
        /*#__PURE__*/ _createElementVNode("th", null, "Costo Base $"),
        /*#__PURE__*/ _createElementVNode("th", null, "Dto 1 %"),
        /*#__PURE__*/ _createElementVNode("th", null, "Dto 2 %"),
        /*#__PURE__*/ _createElementVNode("th", { class: "text-end" }, "Subtotal")
    ])
], -1 /* HOISTED */));
const _hoisted_37 = { class: "product-thumb" };
const _hoisted_38 = ["src", "onError"];
const _hoisted_39 = {
    key: 1,
    class: "lni lni-package"
};
const _hoisted_40 = { class: "font-bold d-block text-slate-800" };
const _hoisted_41 = { class: "code-badge mt-1" };
const _hoisted_42 = { class: "font-medium d-block" };
const _hoisted_43 = { class: "code-badge mt-1" };
const _hoisted_44 = { class: "text-center" };
const _hoisted_45 = { class: "count-pill muted" };
const _hoisted_46 = { class: "text-center font-bold" };
const _hoisted_47 = { class: "input-prefix-wrap" };
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "prefix" }, "$", -1 /* HOISTED */));
const _hoisted_49 = ["onUpdate:modelValue"];
const _hoisted_50 = ["onUpdate:modelValue"];
const _hoisted_51 = ["onUpdate:modelValue"];
const _hoisted_52 = { class: "text-end font-bold" };
const _hoisted_53 = { class: "audit-side-col" };
const _hoisted_54 = { class: "panel-section" };
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "section-icon-title mb-3" }, [
    /*#__PURE__*/ _createElementVNode("div", { class: "section-icon amber" }, [
        /*#__PURE__*/ _createElementVNode("i", { class: "lni lni-stats-up" })
    ]),
    /*#__PURE__*/ _createElementVNode("h3", { class: "section-title" }, "Totalización")
], -1 /* HOISTED */));
const _hoisted_56 = { class: "totals-stack" };
const _hoisted_57 = { class: "total-row" };
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Total Bruto", -1 /* HOISTED */));
const _hoisted_59 = { class: "total-val" };
const _hoisted_60 = { class: "total-row discount" };
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Total Descuentos", -1 /* HOISTED */));
const _hoisted_62 = { class: "total-val text-danger" };
const _hoisted_63 = { class: "total-row net" };
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "fw-bold" }, "TOTAL NETO A PAGAR", -1 /* HOISTED */));
const _hoisted_65 = { class: "total-val-big text-success" };
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "hint-box mt-4" }, [
    /*#__PURE__*/ _createElementVNode("i", { class: "lni lni-information" }),
    /*#__PURE__*/ _createElementVNode("p", null, [
        /*#__PURE__*/ _createTextVNode("Asegúrese de que el "),
        /*#__PURE__*/ _createElementVNode("strong", null, "Total Neto"),
        /*#__PURE__*/ _createTextVNode(" cuadra al centavo con el documento físico del proveedor antes de cerrar.")
    ])
], -1 /* HOISTED */));
const _hoisted_67 = {
    key: 0,
    class: "docs-section mt-4"
};
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h4", { class: "docs-title" }, "Documentos de Respaldo", -1 /* HOISTED */));
const _hoisted_69 = { class: "docs-grid" };
const _hoisted_70 = {
    key: 0,
    class: "doc-pdf-preview"
};
const _hoisted_71 = ["onClick"];
const _hoisted_72 = { class: "pdf-overlay" };
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Ver PDF en pantalla completa", -1 /* HOISTED */));
const _hoisted_74 = ["src"];
const _hoisted_75 = {
    class: "text-muted d-block text-center mt-2",
    style: { "font-size": "0.75rem" }
};
const _hoisted_76 = {
    key: 1,
    class: "doc-image-preview"
};
const _hoisted_77 = ["onClick"];
const _hoisted_78 = ["src", "alt"];
const _hoisted_79 = {
    class: "text-muted d-block text-center mt-1",
    style: { "font-size": "0.75rem" }
};
const _hoisted_80 = { class: "side-actions" };
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "lni lni-checkmark-circle" }, null, -1 /* HOISTED */));
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "lni lni-save" }, null, -1 /* HOISTED */));
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "lni lni-reload" }, null, -1 /* HOISTED */));
const _hoisted_84 = { class: "viewer-modal-content" };
const _hoisted_85 = { class: "viewer-header" };
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h3", { class: "viewer-title" }, "Visualizando Documento de Respaldo", -1 /* HOISTED */));
const _hoisted_87 = { class: "viewer-body" };
const _hoisted_88 = ["src"];
const _hoisted_89 = ["src"];
import { ref, computed, onMounted, watch } from 'vue';
import { ComprasService } from '../../../services/ComprasService';
import { config } from '@/config';
import Swal from 'sweetalert2';
import { FileTextIcon, XIcon } from 'lucide-vue-next';
export default /*#__PURE__*/ _defineComponent({
    __name: 'Fase3Verificacion',
    setup(__props) {
        const ingresosPendientes = ref([]);
        const selectedIngreso = ref(null);
        const detallesMutable = ref([]);
        const isDirty = ref(false);
        const viewer = ref({ isOpen: false, url: '', isPdf: false });
        const openViewer = (m) => {
            viewer.value = {
                isOpen: true,
                url: m.url,
                isPdf: m.url.toLowerCase().endsWith('.pdf')
            };
        };
        const closeViewer = () => {
            viewer.value.isOpen = false;
        };
        watch(detallesMutable, (newVal, oldVal) => {
            if (oldVal && oldVal.length > 0) {
                isDirty.value = true;
            }
        }, { deep: true });
        onMounted(() => {
            loadIngresos();
        });
        const loadIngresos = async () => {
            try {
                const res = await ComprasService.getIngresos();
                ingresosPendientes.value = (res || []).filter((i) => i.estadoCompraId === 2);
            }
            catch (error) {
                console.error(error);
            }
        };
        const seleccionarIngreso = async (ingreso) => {
            try {
                const full = await ComprasService.getIngresoById(ingreso.ingresoCompraId);
                selectedIngreso.value = full;
                detallesMutable.value = (full.detalles || []).map((d) => ({
                    ...d,
                    nombreProductoProveedor: d.nombreProductoProveedor || d.NombreProductoProveedor || '',
                    referenciaProductoProveedor: d.referenciaProductoProveedor || d.ReferenciaProductoProveedor || '',
                    cantidadOriginal: d.cantidadOriginal || 0,
                    imagenRuta: d.imagePath || (d.repuestoId ? `${config.API_URL}/api/Multimedia/repuesto/${d.repuestoId}/thumbnail` : null)
                }));
                setTimeout(() => { isDirty.value = false; }, 100);
            }
            catch (error) {
                Swal.fire({ icon: 'error', text: 'Error al cargar desglose' });
            }
        };
        const calcularSubtotal = (det) => {
            const precio = parseFloat(det.precioBaseFactura) || 0;
            const cant = parseFloat(det.cantidad) || 0;
            let sub = precio * cant;
            const dto1 = parseFloat(det.descuento1Porcentaje) || 0;
            const dto2 = parseFloat(det.descuento2Porcentaje) || 0;
            if (dto1 > 0)
                sub = sub * (1 - (dto1 / 100));
            if (dto2 > 0)
                sub = sub * (1 - (dto2 / 100));
            return sub;
        };
        const totalBruto = computed(() => detallesMutable.value.reduce((acc, curr) => acc + (curr.precioBaseFactura * curr.cantidad), 0));
        const totalDescuentos = computed(() => totalBruto.value - totalNeto.value);
        const totalNeto = computed(() => detallesMutable.value.reduce((acc, curr) => acc + calcularSubtotal(curr), 0));
        const guardarCambios = async (aprobar) => {
            const payload = {
                tipoDocumento: selectedIngreso.value.tipoDocumento,
                numeroDocumento: selectedIngreso.value.numeroDocumento,
                fechaFacturacion: selectedIngreso.value.fechaFacturacion,
                diasCredito: selectedIngreso.value.diasCredito,
                proveedorId: selectedIngreso.value.proveedorId,
                monedaId: selectedIngreso.value.monedaId,
                detalles: detallesMutable.value.map(d => ({
                    nombreProductoProveedor: d.nombreProductoProveedor || d.NombreProductoProveedor,
                    referenciaProductoProveedor: d.referenciaProductoProveedor || d.ReferenciaProductoProveedor,
                    repuestoId: d.repuestoId || null,
                    cantidad: d.cantidad,
                    precioBaseFactura: d.precioBaseFactura,
                    descuento1Porcentaje: d.descuento1Porcentaje,
                    descuento2Porcentaje: d.descuento2Porcentaje,
                }))
            };
            try {
                await ComprasService.updateIngreso(selectedIngreso.value.ingresoCompraId, payload);
                if (!aprobar) {
                    Swal.fire({ toast: true, position: 'top-end', icon: 'success', title: 'Borrador Guardado', timer: 2500, showConfirmButton: false, timerProgressBar: true });
                    loadIngresos();
                    isDirty.value = false;
                }
            }
            catch (error) {
                Swal.fire({ icon: 'error', text: 'Error de red al guardar' });
                throw error;
            }
        };
        const cerrarCuadre = async () => {
            const result = await Swal.fire({
                title: '¿Cerrar Cuadre?',
                text: "Asegúrese de que el total neto cuadre exactamente con su factura física.",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#10b981',
                cancelButtonColor: '#ef4444',
                confirmButtonText: 'Sí, cerrar y totalizar',
                cancelButtonText: 'Revisar de nuevo'
            });
            if (result.isConfirmed) {
                try {
                    await guardarCambios(true);
                    await ComprasService.aprobarIngreso(selectedIngreso.value.ingresoCompraId);
                    Swal.fire({ toast: true, position: 'top-end', icon: 'success', title: '¡Cuadre Cerrado!', text: 'Ingreso listo para transferencia.', timer: 4000, showConfirmButton: false, timerProgressBar: true });
                    selectedIngreso.value = null;
                    loadIngresos();
                }
                catch (e) { }
            }
        };
        const cancelarRevision = () => {
            if (!isDirty.value) {
                selectedIngreso.value = null;
                loadIngresos();
                return;
            }
            Swal.fire({
                title: '¿Cancelar Revisión?',
                text: "Tienes cambios sin guardar.",
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: 'Sí, salir',
                cancelButtonText: 'Continuar auditando'
            }).then(result => {
                if (result.isConfirmed) {
                    selectedIngreso.value = null;
                    loadIngresos();
                }
            });
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createCommentVNode(" ── Phase Header ── "),
                _createElementVNode("div", _hoisted_2, [
                    _hoisted_3,
                    (selectedIngreso.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                            _createElementVNode("button", {
                                class: "btn-secondary-action",
                                onClick: _cache[0] || (_cache[0] = ($event) => (guardarCambios(false)))
                            }, [
                                _hoisted_5,
                                _createTextVNode(" Guardar Borrador ")
                            ]),
                            _createElementVNode("button", {
                                class: "btn-primary-action",
                                onClick: cerrarCuadre
                            }, [
                                _hoisted_6,
                                _createTextVNode(" Cerrar Cuadre ")
                            ])
                        ]))
                        : _createCommentVNode("v-if", true)
                ]),
                _createCommentVNode(" ── Selección de Ingreso ── "),
                (!selectedIngreso.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("div", _hoisted_9, [
                                _hoisted_10,
                                _hoisted_11,
                                (ingresosPendientes.value.length > 0)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(ingresosPendientes.value.length), 1 /* TEXT */))
                                    : _createCommentVNode("v-if", true)
                            ]),
                            (ingresosPendientes.value.length === 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_16))
                                : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                    _createElementVNode("table", _hoisted_18, [
                                        _hoisted_19,
                                        _createElementVNode("tbody", null, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ingresosPendientes.value, (ing) => {
                                                return (_openBlock(), _createElementBlock("tr", {
                                                    key: ing.ingresoCompraId
                                                }, [
                                                    _createElementVNode("td", null, [
                                                        _createElementVNode("span", _hoisted_20, _toDisplayString(ing.numeroDocumento), 1 /* TEXT */),
                                                        _createElementVNode("small", _hoisted_21, _toDisplayString(ing.tipoDocumento), 1 /* TEXT */)
                                                    ]),
                                                    _createElementVNode("td", _hoisted_22, _toDisplayString(ing.nombreProveedor), 1 /* TEXT */),
                                                    _createElementVNode("td", null, [
                                                        _createElementVNode("span", _hoisted_23, _toDisplayString(ing.nombreMoneda), 1 /* TEXT */)
                                                    ]),
                                                    _createElementVNode("td", _hoisted_24, "$" + _toDisplayString((ing.totalDocumento || 0).toFixed(2)), 1 /* TEXT */),
                                                    _createElementVNode("td", _hoisted_25, [
                                                        _createElementVNode("span", _hoisted_26, _toDisplayString(ing.nombreEstado), 1 /* TEXT */)
                                                    ]),
                                                    _createElementVNode("td", _hoisted_27, [
                                                        _createElementVNode("button", {
                                                            class: "btn-action-sm",
                                                            onClick: ($event) => (seleccionarIngreso(ing))
                                                        }, [
                                                            _hoisted_29,
                                                            _createTextVNode(" Verificar ")
                                                        ], 8 /* PROPS */, _hoisted_28)
                                                    ])
                                                ]));
                                            }), 128 /* KEYED_FRAGMENT */))
                                        ])
                                    ])
                                ]))
                        ])
                    ]))
                    : _createCommentVNode("v-if", true),
                _createCommentVNode(" ── Vista Principal: Verificación ── "),
                (selectedIngreso.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                        _createCommentVNode(" LEFT: Tabla detalles "),
                        _createElementVNode("div", _hoisted_31, [
                            _createElementVNode("div", _hoisted_32, [
                                _hoisted_33,
                                _createElementVNode("div", _hoisted_34, [
                                    _createElementVNode("table", _hoisted_35, [
                                        _hoisted_36,
                                        _createElementVNode("tbody", null, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detallesMutable.value, (det, idx) => {
                                                return (_openBlock(), _createElementBlock("tr", {
                                                    key: idx,
                                                    class: _normalizeClass({ 'row-discrepancy': det.cantidad !== det.cantidadOriginal, 'row-linked': det.cantidad === det.cantidadOriginal })
                                                }, [
                                                    _createElementVNode("td", null, [
                                                        _createElementVNode("div", _hoisted_37, [
                                                            (det.imagenRuta)
                                                                ? (_openBlock(), _createElementBlock("img", {
                                                                    key: 0,
                                                                    src: det.imagenRuta,
                                                                    onError: ($event) => (det.imagenRuta = null)
                                                                }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_38))
                                                                : (_openBlock(), _createElementBlock("i", _hoisted_39))
                                                        ])
                                                    ]),
                                                    _createElementVNode("td", null, [
                                                        _createElementVNode("span", _hoisted_40, _toDisplayString(det.nombreProductoProveedor || 'N/A'), 1 /* TEXT */),
                                                        _createElementVNode("span", _hoisted_41, _toDisplayString(det.referenciaProductoProveedor || 'N/A'), 1 /* TEXT */)
                                                    ]),
                                                    _createElementVNode("td", null, [
                                                        _createElementVNode("span", _hoisted_42, _toDisplayString(det.nombreRepuesto || '- Sin Vincular -'), 1 /* TEXT */),
                                                        _createElementVNode("span", _hoisted_43, _toDisplayString(det.codigoRepuesto || 'SIN REF'), 1 /* TEXT */)
                                                    ]),
                                                    _createElementVNode("td", _hoisted_44, [
                                                        _createElementVNode("span", _hoisted_45, _toDisplayString(det.cantidadOriginal || '-'), 1 /* TEXT */)
                                                    ]),
                                                    _createElementVNode("td", _hoisted_46, _toDisplayString(det.cantidad), 1 /* TEXT */),
                                                    _createElementVNode("td", null, [
                                                        _createElementVNode("div", _hoisted_47, [
                                                            _hoisted_48,
                                                            _withDirectives(_createElementVNode("input", {
                                                                type: "number",
                                                                step: "0.01",
                                                                class: "input-sm",
                                                                "onUpdate:modelValue": ($event) => ((det.precioBaseFactura) = $event)
                                                            }, null, 8 /* PROPS */, _hoisted_49), [
                                                                [
                                                                    _vModelText,
                                                                    det.precioBaseFactura,
                                                                    void 0,
                                                                    { number: true }
                                                                ]
                                                            ])
                                                        ])
                                                    ]),
                                                    _createElementVNode("td", null, [
                                                        _withDirectives(_createElementVNode("input", {
                                                            type: "number",
                                                            step: "0.01",
                                                            class: "input-sm text-center",
                                                            "onUpdate:modelValue": ($event) => ((det.descuento1Porcentaje) = $event)
                                                        }, null, 8 /* PROPS */, _hoisted_50), [
                                                            [
                                                                _vModelText,
                                                                det.descuento1Porcentaje,
                                                                void 0,
                                                                { number: true }
                                                            ]
                                                        ])
                                                    ]),
                                                    _createElementVNode("td", null, [
                                                        _withDirectives(_createElementVNode("input", {
                                                            type: "number",
                                                            step: "0.01",
                                                            class: "input-sm text-center",
                                                            "onUpdate:modelValue": ($event) => ((det.descuento2Porcentaje) = $event)
                                                        }, null, 8 /* PROPS */, _hoisted_51), [
                                                            [
                                                                _vModelText,
                                                                det.descuento2Porcentaje,
                                                                void 0,
                                                                { number: true }
                                                            ]
                                                        ])
                                                    ]),
                                                    _createElementVNode("td", _hoisted_52, "$" + _toDisplayString(calcularSubtotal(det).toFixed(2)), 1 /* TEXT */)
                                                ], 2 /* CLASS */));
                                            }), 128 /* KEYED_FRAGMENT */))
                                        ])
                                    ])
                                ])
                            ])
                        ]),
                        _createCommentVNode(" RIGHT: Totalización "),
                        _createElementVNode("div", _hoisted_53, [
                            _createElementVNode("div", _hoisted_54, [
                                _hoisted_55,
                                _createElementVNode("div", _hoisted_56, [
                                    _createElementVNode("div", _hoisted_57, [
                                        _hoisted_58,
                                        _createElementVNode("span", _hoisted_59, "$" + _toDisplayString(totalBruto.value.toFixed(2)), 1 /* TEXT */)
                                    ]),
                                    _createElementVNode("div", _hoisted_60, [
                                        _hoisted_61,
                                        _createElementVNode("span", _hoisted_62, "-$" + _toDisplayString(totalDescuentos.value.toFixed(2)), 1 /* TEXT */)
                                    ]),
                                    _createElementVNode("div", _hoisted_63, [
                                        _hoisted_64,
                                        _createElementVNode("span", _hoisted_65, "$" + _toDisplayString(totalNeto.value.toFixed(2)), 1 /* TEXT */)
                                    ])
                                ]),
                                _hoisted_66,
                                _createCommentVNode(" Documentos Adjuntos "),
                                (selectedIngreso.value && selectedIngreso.value.multimedia && selectedIngreso.value.multimedia.length > 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                                        _hoisted_68,
                                        _createElementVNode("div", _hoisted_69, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedIngreso.value.multimedia, (m) => {
                                                return (_openBlock(), _createElementBlock(_Fragment, {
                                                    key: m.id
                                                }, [
                                                    (m.url.endsWith('.pdf'))
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                                                            _createElementVNode("div", {
                                                                class: "pdf-container",
                                                                onClick: ($event) => (openViewer(m)),
                                                                title: "Haz clic para ver en pantalla completa"
                                                            }, [
                                                                _createElementVNode("div", _hoisted_72, [
                                                                    _createVNode(_unref(FileTextIcon), {
                                                                        size: 32,
                                                                        class: "mb-2"
                                                                    }),
                                                                    _hoisted_73
                                                                ]),
                                                                _createElementVNode("iframe", {
                                                                    src: m.url + '#toolbar=0&navpanes=0&scrollbar=0',
                                                                    frameborder: "0",
                                                                    scrolling: "no",
                                                                    class: "pdf-mini-viewer"
                                                                }, null, 8 /* PROPS */, _hoisted_74)
                                                            ], 8 /* PROPS */, _hoisted_71),
                                                            _createElementVNode("small", _hoisted_75, _toDisplayString(m.nombreOriginal || 'Documento PDF'), 1 /* TEXT */)
                                                        ]))
                                                        : (_openBlock(), _createElementBlock("div", _hoisted_76, [
                                                            _createElementVNode("a", {
                                                                href: "#",
                                                                onClick: _withModifiers(($event) => (openViewer(m)), ["prevent"]),
                                                                title: "Ver imagen en grande"
                                                            }, [
                                                                _createElementVNode("img", {
                                                                    src: m.url,
                                                                    alt: m.nombreOriginal,
                                                                    class: "img-fluid rounded",
                                                                    style: { "max-height": "200px", "object-fit": "contain", "width": "100%", "border": "1px solid #e2e8f0", "cursor": "zoom-in" }
                                                                }, null, 8 /* PROPS */, _hoisted_78)
                                                            ], 8 /* PROPS */, _hoisted_77),
                                                            _createElementVNode("small", _hoisted_79, _toDisplayString(m.nombreOriginal), 1 /* TEXT */)
                                                        ]))
                                                ], 64 /* STABLE_FRAGMENT */));
                                            }), 128 /* KEYED_FRAGMENT */))
                                        ])
                                    ]))
                                    : _createCommentVNode("v-if", true),
                                _createElementVNode("div", _hoisted_80, [
                                    _createElementVNode("button", {
                                        class: "btn-primary-action full-w",
                                        onClick: cerrarCuadre
                                    }, [
                                        _hoisted_81,
                                        _createTextVNode(" Cerrar Cuadre ")
                                    ]),
                                    _createElementVNode("button", {
                                        class: "btn-secondary-action full-w",
                                        onClick: _cache[1] || (_cache[1] = ($event) => (guardarCambios(false)))
                                    }, [
                                        _hoisted_82,
                                        _createTextVNode(" Guardar Borrador ")
                                    ]),
                                    _createElementVNode("button", {
                                        class: "btn-outline-danger-sm full-w",
                                        onClick: cancelarRevision
                                    }, [
                                        _hoisted_83,
                                        _createTextVNode(" Cancelar Revisión ")
                                    ])
                                ])
                            ])
                        ])
                    ]))
                    : _createCommentVNode("v-if", true),
                _createCommentVNode(" ── Modal Visor de Documentos ── "),
                _createVNode(_Transition, { name: "fade" }, {
                    default: _withCtx(() => [
                        (viewer.value.isOpen)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "modal-overlay-express",
                                onClick: _withModifiers(closeViewer, ["self"])
                            }, [
                                _createElementVNode("div", _hoisted_84, [
                                    _createElementVNode("div", _hoisted_85, [
                                        _hoisted_86,
                                        _createElementVNode("button", {
                                            class: "btn-close-viewer",
                                            onClick: closeViewer
                                        }, [
                                            _createVNode(_unref(XIcon), { size: 24 })
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_87, [
                                        (viewer.value.isPdf)
                                            ? (_openBlock(), _createElementBlock("iframe", {
                                                key: 0,
                                                src: viewer.value.url,
                                                frameborder: "0",
                                                class: "viewer-iframe"
                                            }, null, 8 /* PROPS */, _hoisted_88))
                                            : (_openBlock(), _createElementBlock("img", {
                                                key: 1,
                                                src: viewer.value.url,
                                                class: "viewer-image"
                                            }, null, 8 /* PROPS */, _hoisted_89))
                                    ])
                                ])
                            ]))
                            : _createCommentVNode("v-if", true)
                    ]),
                    _: 1 /* STABLE */
                })
            ]));
        };
    }
});
